import { render, staticRenderFns } from "./AvailabilityServiceLayout.vue?vue&type=template&id=463b99ac"
import script from "./AvailabilityServiceLayout.vue?vue&type=script&lang=js"
export * from "./AvailabilityServiceLayout.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityServiceLayout.vue?vue&type=style&index=0&id=463b99ac&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports